/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { OrgUnitReserveSectionsListPathOrgUnitId, OrgUnitReserveSectionsListStatus200 } from "../types/OrgUnitReserveSectionsList.ts";

function getOrgUnitReserveSectionsListUrl(org_unit_id: OrgUnitReserveSectionsListPathOrgUnitId) {
	const res = { method: "GET", url: `/api/org_unit/${org_unit_id}/reserve/sections/` as const };

	return res;
}

/**
 * @summary залы точки со столами и схемой для бронирования
 * {@link /api/org_unit/:org_unit_id/reserve/sections/}
 */
export async function orgUnitReserveSectionsList(
	org_unit_id: OrgUnitReserveSectionsListPathOrgUnitId,
	config: Partial<RequestConfig> & { client?: Client } = {},
) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<OrgUnitReserveSectionsListStatus200, ResponseErrorConfig<Error>, unknown>({
		method: "GET",
		url: getOrgUnitReserveSectionsListUrl(org_unit_id).url.toString(),
		...requestConfig,
	});

	return res.data;
}
